import { render, staticRenderFns } from "./StandardPaymentRequest.vue?vue&type=template&id=1e5ceb65&scoped=true&"
import script from "./StandardPaymentRequest.vue?vue&type=script&lang=js&"
export * from "./StandardPaymentRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5ceb65",
  null
  
)

export default component.exports